import { render, staticRenderFns } from "./AppNavigationHeaderTodayButton.vue?vue&type=template&id=6ef30bfd"
import script from "./AppNavigationHeaderTodayButton.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeaderTodayButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports